import { useForm } from '../../forms/hocs/form.context'
import { FilterName } from '../../__generated__/fed-graphql-types'

export interface UseSearchType {
    isFinanceSearch?: boolean
    isNewSearch?: boolean
}

export const useSearchType = (): UseSearchType => {
    const { hasSelected } = useForm()

    return {
        isFinanceSearch: hasSelected(FilterName.price_search_type, 'monthly'),
        isNewSearch: hasSelected(FilterName.min_year_manufactured, 'new'),
    }
}
